if (!customElements.get("m-comparison-table")) {
  class MComparisonTable extends HTMLElement {
    constructor() {
      super();
      this.onCtaClick = this.onCtaClick.bind(this);
    }

    connectedCallback() {
      this.ctaButtons = this.querySelectorAll("[data-ct-scroll-cta]");
      this.ctaButtons.forEach((button) => {
        button.addEventListener("click", this.onCtaClick);
      });
    }

    disconnectedCallback() {
      this.ctaButtons.forEach((button) => {
        button.removeEventListener("click", this.onCtaClick);
      });
    }

    prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    onCtaClick(event) {
      const target =
        document.querySelector(".m-main-product--info") ||
        document.querySelector("product-info[id^='MainProduct']");

      if (!target) return;

      event.preventDefault();

      const header = document.querySelector("sticky-header, .m-header, #shopify-section-header");
      const offset = header ? header.getBoundingClientRect().height : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset - 12;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: this.prefersReducedMotion() ? "auto" : "smooth",
      });
    }
  }

  customElements.define("m-comparison-table", MComparisonTable);
}
